module.exports = __webpack_public_path__ + "static/img/病历质量与临床路径一致性审核.1e2e7ce4.png";